import { useState } from "react";
import TitleTextSection from "../TitelTextSection";

const UserEventsSection = ({ likedBands = [], followedBands = [], notifications = [] }) => {
  const [activeTab, setActiveTab] = useState(null);
  const [visibleNotifications, setVisibleNotifications] = useState(5);

  const toggleTab = (tab) => {
    if (activeTab === tab) {
      setActiveTab(null);
    } else {
      setActiveTab(tab);
    }
  };

  const handleLoadMore = () => {
    setVisibleNotifications((prev) => Math.min(100, prev + 10));
  };

  return (
    <div className="bg-[#131313] p-6 my-6 card border border-white/10 rounded-2xl shadow-lg">
      <div className="pb-4">
        <TitleTextSection title="Dina händelser" />
      </div>

      <div className="flex flex-col gap-4">
        {/* Liked and Followed Buttons */}
        <div className="flex gap-4">
          <button
            onClick={() => toggleTab("likes")}
            className={`flex flex-col items-center justify-center p-3 rounded-xl border transition-all duration-200 w-28 ${
              activeTab === "likes"
                ? "bg-[#0047ff] text-white border-none shadow-[0_4px_15px_rgba(0,71,255,0.35)]"
                : "bg-[#181818] hover:bg-neutral-800 border-white/10 text-stone-300"
            }`}
          >
            <span className="text-2xl font-black">{likedBands.length}</span>
            <span className="text-[10px] uppercase tracking-wider font-bold mt-1">Likat</span>
          </button>

          <button
            onClick={() => toggleTab("follows")}
            className={`flex flex-col items-center justify-center p-3 rounded-xl border transition-all duration-200 w-28 ${
              activeTab === "follows"
                ? "bg-[#0047ff] text-white border-none shadow-[0_4px_15px_rgba(0,71,255,0.35)]"
                : "bg-[#181818] hover:bg-neutral-800 border-white/10 text-stone-300"
            }`}
          >
            <span className="text-2xl font-black">{followedBands.length}</span>
            <span className="text-[10px] uppercase tracking-wider font-bold mt-1">Följer</span>
          </button>
        </div>

        {/* Toggled Lists */}
        {activeTab === "likes" && (
          <div className="mt-2 p-5 bg-black/30 rounded-xl border border-white/10">
            <h4 className="font-bold mb-3 text-xs text-stone-400 uppercase tracking-wider border-b border-white/5 pb-2">
              Profiler du gillar
            </h4>
            {likedBands.length === 0 ? (
              <p className="text-xs text-stone-500 italic">Du har inte likat några profiler än.</p>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {likedBands.map((band) => (
                  <a
                    key={band.id}
                    href={`/music/${band.slug}`}
                    className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-neutral-800 transition-colors border border-transparent hover:border-white/5"
                  >
                    <div className="avatar">
                      <div className="w-8 h-8 rounded-full bg-neutral-900 text-neutral-content flex items-center justify-center overflow-hidden border border-white/10">
                        {band.image_profile ? (
                          <img
                            src={band.image_profile}
                            alt={band.name}
                            className="object-cover"
                          />
                        ) : (
                          <span className="text-[10px] uppercase font-bold">
                            {band.name.slice(0, 2)}
                          </span>
                        )}
                      </div>
                    </div>
                    <span className="text-sm font-bold text-stone-200 hover:text-[#0047ff] transition-colors truncate">
                      {band.name}
                    </span>
                  </a>
                ))}
              </div>
            )}
          </div>
        )}

        {activeTab === "follows" && (
          <div className="mt-2 p-5 bg-black/30 rounded-xl border border-white/10">
            <h4 className="font-bold mb-3 text-xs text-stone-400 uppercase tracking-wider border-b border-white/5 pb-2">
              Profiler du följer
            </h4>
            {followedBands.length === 0 ? (
              <p className="text-xs text-stone-500 italic">Du följer inga profiler än.</p>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                {followedBands.map((band) => (
                  <a
                    key={band.id}
                    href={`/music/${band.slug}`}
                    className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-neutral-800 transition-colors border border-transparent hover:border-white/5"
                  >
                    <div className="avatar">
                      <div className="w-8 h-8 rounded-full bg-neutral-900 text-neutral-content flex items-center justify-center overflow-hidden border border-white/10">
                        {band.image_profile ? (
                          <img
                            src={band.image_profile}
                            alt={band.name}
                            className="object-cover"
                          />
                        ) : (
                          <span className="text-[10px] uppercase font-bold">
                            {band.name.slice(0, 2)}
                          </span>
                        )}
                      </div>
                    </div>
                    <span className="text-sm font-bold text-stone-200 hover:text-[#0047ff] transition-colors truncate">
                      {band.name}
                    </span>
                  </a>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Notifications List */}
        <div className="border-t border-white/10 pt-6">
          <h4 className="font-bold mb-4 text-xs text-stone-400 uppercase tracking-wider">
            Senaste händelser
          </h4>
          {notifications.length === 0 ? (
            <p className="text-xs text-stone-500 italic">Det har inte hänt något än.</p>
          ) : (
            <div className="flex flex-col gap-2.5">
              {notifications.slice(0, visibleNotifications).map((notif) => {
                const content = (
                  <div className="flex justify-between items-start gap-4 p-4 bg-[#181818] rounded-xl border border-white/5 hover:border-white/10 transition-colors h-full shadow-sm">
                    <div className="flex flex-col min-w-0">
                      <span className="font-extrabold text-sm text-white truncate">
                        {notif.title}
                      </span>
                      <p className="text-xs text-stone-400 mt-1 break-words leading-relaxed">
                        {notif.message}
                      </p>
                    </div>
                    <span className="text-[10px] text-stone-500 font-semibold whitespace-nowrap pt-0.5">
                      {new Date(notif.created_at).toLocaleDateString("sv-SE", {
                        month: "short",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  </div>
                );

                if (notif.target_url) {
                  return (
                    <a
                      key={notif.id}
                      href={notif.target_url}
                      className="block hover:no-underline"
                    >
                      {content}
                    </a>
                  );
                }

                return <div key={notif.id}>{content}</div>;
              })}

              {visibleNotifications < notifications.length && visibleNotifications < 100 && (
                <div className="flex justify-center mt-3">
                  <button
                    onClick={handleLoadMore}
                    className="text-xs font-bold text-[#0047ff] hover:text-blue-400 transition-colors cursor-pointer uppercase tracking-wider py-2"
                  >
                    Läs in fler
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserEventsSection;
